<template>
	<div class="agreement">
	    <h3>{{$t('d.agree1')}}</h3>
	    <div classs="">{{$t('d.agree2')}}</div>
	    <div class="tips">
			{{$t('d.agree3')}}
			<a href="/#/about/35" target="_blank">
				<i>《User Agreement》</i>
			</a>
			<a href="/#/about/35" target="_blank">
				<i>《Conditions of Use》</i>
			</a>
			{{$t('d.agree4')}}
	    </div>
	    <div class="tips">{{$t('d.agree5')}}</div>
	    <div class="button">
	        <div class="agree">
	            <img class="noAgree"  src="../images/shop2/agree.png" alt="">
	            <img class="agrees" src="../images/shop2/agree.png" alt="">
				{{$t('d.agree6')}}
	        </div>
	        <div class="join"><a href="/#/index" class="wziys">{{$t('d.agree7')}}</a></div>
	    </div>
	</div>

</template>

<script>
	import Vue from 'vue';
	export default {
		name: "agree",
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn"
			};
		},
		mounted() {
			this.$parent.footer('index',false);
		},
		methods: {
			
		}
	};
</script>
<style lang="less" scoped>
	.agreement div{
		font-size: 16px;
	}
	.agreement{
		padding:20px 10px;
		line-height: 30px;
	}
	.agreement>h3{
		text-align: center;
		color:#d71c20;
		line-height: 30px;
		font-size: 18px;
		margin: 18px;
	}
  
	.agreement>.tips{
		margin-top: 30px;
		line-height: 30px;
	}
	.agreement i{
		color:#d71c20;
		font-size: 14px;
		font-style: normal;
	}
	.button{
		position: fixed;
		bottom: 0;
		width:100%;
		height:50px;
		left:0;
		display: flex;
		align-items: center;
		border-top:1px solid #f24255;
	}
	.button>div{
		flex:1;
		display: flex;
		align-items: center;
		justify-content: center;
		height:100%;
		font-size: 14px;
	}
	.button>div:first-child{

		color:#d71c20;
	}
	.button>div:last-child{
		background: #f24255;
		color:#fff;
	}
	.button img{
		display: inline-block;
		width: 16px;
		height: 16px;

	}
	.button .agree .agrees{
		display: none;
	}
	.wziys {
		color: #fff;
		width:100%;
		height: 35px;
		line-height: 35px;
		text-align: center;
		background: #f24255;
		flex: 1;
	}
</style>
